import { render, staticRenderFns } from "./HouseComponentDefectGroup.vue?vue&type=template&id=46328096&"
import script from "./HouseComponentDefectGroup.vue?vue&type=script&lang=js&"
export * from "./HouseComponentDefectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports